export default __webpack_public_path__ + "static/media/bg-exclusive.3fba7c4b.webp";